module.exports = __webpack_public_path__ + "img/testy3.426e60fe.jpg";